









































































import { Component, Vue } from 'vue-property-decorator';
import { ApiService, curApiService } from '@/services/ApiService';
import { curPref, Preferences } from '@/services/Preferences';
import { BaseStation, BssPage } from '@/types';
import Error from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import SearchBox from '@/components/SearchBox.vue';
import PageNav from '@/components/PageNav.vue';
import BaseStationRow from '@/components/base-stations/BaseStationRow.vue';
import BaseStationRowMobile from '@/components/base-stations/BaseStationRowMobile.vue';

@Component({
  components: {
    Error,
    Loading,
    BaseStationRow,
    BaseStationRowMobile,
    SearchBox,
    PageNav,
  },
})
export default class BaseStations extends Vue {
  
  httpBusy:boolean = false;
  error:string = '';
  pageList:BssPage[] = [];
  curPage:BssPage = {} as BssPage;
  searchTerm = curPref.retrieve('base-stations-search-term', '');
  
  // services
  apiService:ApiService = curApiService;
  
  mounted() {

    if(this.$route.params.searchTerm)
      this.searchTerm = this.$route.params.searchTerm;

    this.refreshData();
  }

  async refreshData() {

    this.httpBusy = true;
    const reply = await this.apiService.getBaseStations({searchTerm: this.searchTerm});
    this.httpBusy = false;
    
    if(reply.errorMsg)
      return this.error = `Unable to load base stations because ${reply.errorMsg}`;

    this.pageList = reply.pageList!;

    // we set the current page
    if(this.pageList.length > 0) {

      // we call the reset on the component
      (this.$refs.pageNav as PageNav).reset();

      this.curPage = this.pageList[0];
    }
      
  }

  newSearchText(newSearchText:string) {
    curPref.store('base-stations-search-term', newSearchText);
    this.searchTerm = newSearchText;
    this.refreshData();
  }

  get showPageNav():boolean {
    return this.pageList.length > 0 && !this.httpBusy;
  }

  get showBssRows():boolean {
    return this.pageList.length > 0 && !this.httpBusy;
  }

  changePage(newPageNum:number) {
    this.curPage = this.pageList[newPageNum];
  }
}
